import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/common/button/button";
import { AppRoutes } from "../../../../common/routes/app_routes";
import {
  ChangeRequestDtoStatusEnum,
  ChangeRequestDtoTypeEnum,
  type ChangeRequestDto,
} from "../../../../api";
import { useSubmitChangeRequest } from "../../hooks/useChangeRequestMutations";

// Request types whose form reopens the user's saved draft. Other drafts can
// still be submitted as saved, straight from the detail view.
const DRAFT_EDIT_PATHS: Partial<Record<ChangeRequestDto["type"], string>> = {
  [ChangeRequestDtoTypeEnum.BuyerProfileUpdate]: AppRoutes.CHANGE_REQUEST_NEW_BUYER_PROFILE,
};

export interface DraftChangeRequestActionsProps {
  request: ChangeRequestDto;
  /** Another action on the request (e.g. cancelling) is in flight. */
  disabled?: boolean;
}

/** "Continue editing" / "Submit for review" for a saved draft; renders nothing otherwise. */
export function DraftChangeRequestActions({ request, disabled = false }: DraftChangeRequestActionsProps) {
  const navigate = useNavigate();
  const { submitHandler, isLoading: isSubmitting } = useSubmitChangeRequest(request.id);

  if (request.status !== ChangeRequestDtoStatusEnum.Draft) return null;

  const editPath = DRAFT_EDIT_PATHS[request.type];
  const isBusy = disabled || isSubmitting;

  return (
    <>
      {editPath && (
        <Button variant="secondary" disabled={isBusy} onClick={() => navigate(editPath)}>
          Continue editing
        </Button>
      )}
      <Button variant="primary" disabled={isBusy} onClick={() => void submitHandler()}>
        {isSubmitting ? "Submitting…" : "Submit for review"}
      </Button>
    </>
  );
}
